import React from 'react'
import { NavLink } from 'react-router-dom'
import { Option, toRelativeUrl, decodeHTMLEntities, gtmPush } from '../../../helpers'
import { WordPress, withDataState } from '../../wordpress/wordpress_api'

type Props = {
  location: 'main' | 'footer' | 'copyright'
  hasActiveState: boolean
  before?: JSX.Element
  after?: JSX.Element
  cssClass?: string
  showDescription?: boolean
  onClick?: () => void
}

type State = withDataState<WordPress.MenuLocationResponse> & { hover: boolean }

export default class NavItems extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      kind: 'loading',
      hover: false
    }

    this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this)
    this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this)
  }

  componentDidMount() {
    WordPress.findMenuByLocation(this.props.location)
      .then(response => this.setState(s => ({ ...s, kind: 'loaded', data: Option(response.data) })))
      .catch(() => this.setState({ kind: 'error' }))
  }

  handleOnMouseEnter() {
    this.setState(s => ({...s, hover: true }))
  }

  handleOnMouseLeave() {
    this.setState(s => ({ ...s, hover: false }))
  }

  render() {
    let classes = [
      'nav__list',
      this.props.cssClass ? `nav__list--${this.props.cssClass}` : `nav__list--${this.props.location}`,
      this.state.hover ? 'nav__list--hover' : ''
    ]
    return (
      this.state.kind === 'loaded' &&
      this.state.data.kind === 'some' && (
        <>
          <ul className={classes.join(' ')}>
            {this.props.before}
            {this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) => (
              <>
                <li
                  onMouseEnter={this.handleOnMouseEnter}
                  onFocus={this.handleOnMouseEnter}
                  onBlur={this.handleOnMouseLeave}
                  onMouseLeave={this.handleOnMouseLeave}
                  className={`nav__item nav__item--${this.props.location} ${menuItem.classes} ${
                    menuItem.children && menuItem.children.length > 0 ? 'nav__item--has-children' : ''
                  }`}
                  key={`${this.props.location}-${index}`}
                >
                  {this.navItem(menuItem)}
                </li>
                {menuItem.children.length > 0 ? (
                  <>
                    {menuItem.children.map((menuChild: WordPress.MenuItem) => (
                      <li className="`nav__item">{this.navItem(menuChild)}</li>
                    ))}
                  </>
                ) : (
                  ''
                )}
              </>
            ))}
            {this.props.after}
          </ul>
        </>
      )
    )
  }

  navItem(menuItem: WordPress.MenuItem) {
    return menuItem.type == 'custom' ? (
      <a
        href={menuItem.url}
        onClick={() => this.props.onClick}
        className={`nav__link nav__link--${this.props.location}`}
        target={menuItem.target}
      >
        {decodeHTMLEntities(menuItem.title)}
        {this.props.showDescription && (
          <>
            <div className="nav__description">{menuItem.description}</div>
            {menuItem.button_label}
          </>
        )}
      </a>
    ) : (
      <NavLink
        to={toRelativeUrl(menuItem.url)}
        onClick={() => this.props.onClick}
        className={`nav__link nav__link--${this.props.location}`}
        activeClassName={this.props.hasActiveState ? 'nav__link--active' : null}
      >{decodeHTMLEntities(menuItem.title)}
        {this.props.showDescription && (
          <>
            <div className="nav__description">{menuItem.description}</div>
            {menuItem.button_label}
            )}
          </>
        )}
      </NavLink>
    )
  }
}
